'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BRAND_UUID_COOKIE_KEY = exports.BRAND_UUID_COOKIE_KEY = 'brand_uuid';
var BRAND_UUID_COOKIE_EXPIRY_DAYS = exports.BRAND_UUID_COOKIE_EXPIRY_DAYS = 365;
//# sourceMappingURL=cookie-storage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/config/data/cookie-storage.js
// module id = 2015
// module chunks = 0